module.exports = __webpack_public_path__ + "static/img/jigou-anhui-bottom.924a7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-anhui-bottom.png
// module id = Ohle
// module chunks = 1